import React, { useEffect, useState } from 'react'
import { FormulaComponent } from 'src/components/pages/sales/business-rule/logic/FormulaComponent'
import { Skeleton, Box, Typography, Alert, AlertTitle, Button } from '@mui/material'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import {
  formatCheckedBox,
  updateCheckBox,
  waitVariablesFormat,
} from 'src/components/pages/sales/business-rule/helper/vars_helper'
import { checkFormulasBody } from 'src/components/pages/sales/business-rule/helper/checkFormulasBody'
import { mapperHelperService } from 'src/services/auth/mapperHelper.service'
import { operators } from 'src/components/pages/sales/business-rule/logic/ListOperators'
import { lightcyan } from 'src/assets/colors'

export const CardParentFormula = ({
  loading = false,
  initialFormulas = undefined,
  parentInfo = undefined,
}) => {
  const [checkedBox, setCheckedBox] = useState([])
  const [variablesFormat, setVariablesFormat] = useState([])
  const [formulasLoading, setFormulasLoading] = useState(false)
  const [parentFormulas, setParentFormulas] = useState([])
  useEffect(() => {
    if (checkFormulasBody(initialFormulas)) {
      resolveFormula(initialFormulas)
    }
  }, [initialFormulas])

  useEffect(() => {
    let format_checkedBox = formatCheckedBox(checkedBox, operators, variablesFormat, parentFormulas)
    setVariablesFormat(format_checkedBox)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedBox])

  const resolveFormula = async (formula) => {
    try {
      setFormulasLoading(true)
      if (formula?.data) {
        const jsonParse = await mapperHelperService(formula?.data)
        updateCheckBox(jsonParse, formula.data, checkedBox, setCheckedBox)
        await waitVariablesFormat(checkedBox, variablesFormat)
      }
      setFormulasLoading(false)
    } catch (error) {
    }
  }

  if (initialFormulas) {
    return (
      <CheckboxContext.Provider value={{ checkedBox, setCheckedBox, variablesFormat, setVariablesFormat }}>
        <Box
          style={{
            marginRight: '30px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          {loading || formulasLoading ? (
            <Box
              style={{
                width: '60%',
              }}
            >
              <Skeleton variant='rectangular' width={'100%'} height={500} style={{ borderRadius: '15px' }} />
            </Box>
          ) : (
            <Box
              style={{
                padding: '30px',
                backgroundColor: lightcyan,
                borderRadius: '15px',
                width: '60%',
              }}
            >
              <Typography variant='h3' component='h2'>
                Formula de "{parentInfo?.name}"
              </Typography>
              <FormulaComponent
                formulas={parentFormulas}
                setFormulas={setParentFormulas}
                initialFormulas={initialFormulas?.structure}
                onlyView={true}
                withoutValues={true}
              />
              <Box style={{ margin: '10px' }}>
                <Alert severity='info'>
                  <AlertTitle>Guia para crear tu Formula!</AlertTitle>
                  Has seleccionado un regla
                  <strong> padre</strong>, esto te permite remplezar cualquiera de sus{' '}
                  <strong>formulas</strong>.
                  <br />
                  Lo unico que tendras que hacer es crear o seleccionar una variable con el mismo nombre de la
                  formula a <strong> remplazar </strong>
                  por ejemplo si quiere modificar la formula que resuelve la variable <strong>extra</strong>.
                  <br />
                  Deberas crear una formula con la variable <strong>extra</strong> a la cual se le asigne el
                  resultado de una operacion.
                </Alert>
              </Box>
            </Box>
          )}
        </Box>
      </CheckboxContext.Provider>
    )
  }
}
